package io.horion.cv.uiState

import io.horion.cv.models.ExperienceLevel
import io.horion.cv.models.Job
import io.horion.cv.models.JobType
import io.horion.cv.api.datasource.job.ApplyJob

data class JobUiState(
    val loading: Boolean = false,
    val isConnected: Boolean = true,
    val showJobDetails: Boolean = false,
    val error: String? = null,
    val success: String? = null,
    val currentJob: Job = Job(),
    val selectedJob: Job? = null,
    val jobs: List<Job> = emptyList(),
    val applies: List<ApplyJob> = emptyList(),
    val searchQuery: String = "",
    val searchQueryLocation: String = "",
    val filterType: JobType? = null,
    val filterExperienceLevel: ExperienceLevel? = null,
    val filterRemoteOnly: Boolean = false,
)